import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(to right, #e5e7eb 8%, #f3f4f6 18%, #e5e7eb 33%);
  background-size: 800px 104px;
  animation: ${shimmer} 1.2s infinite linear;
  border-radius: 6px;
`;

export const CouponSkeletonContainer = styled.div`
  margin: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const CouponToggleSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 44px;
  border-radius: 8px;
`;

export const CouponInputRowSkeleton = styled.div`
  display: flex;
  gap: 8px;
`;

export const CouponInputSkeleton = styled(SkeletonBase)`
  flex: 1;
  height: 40px;
`;

export const CouponButtonSkeleton = styled(SkeletonBase)`
  width: 91px;
  height: 44px;
`;

export const CouponMessageSkeleton = styled(SkeletonBase)`
  width: 60%;
  height: 14px;
`;
